// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const FindingTypeSchema = z.enum(['VULNERABILITY','MISCONFIGURATION','BEST_PRACTICE'] as const);

export type FindingTypeType = `${z.infer<typeof FindingTypeSchema>}`

export default FindingTypeSchema;
